import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCompanyVehicles } from '../../common_lib_front/hooks/useCompanyVehicles';
import VehicleInfo, { newVehicleInfo } from '../../common_lib_front/types/vehicleInfo';
import SelectTable from '../selectTable/selectTable';

type VehicleSelectProps = {
  id: string;
  vehicle?: VehicleInfo;
  setVehicle: (val: VehicleInfo | undefined) => void;
  required?: boolean;
  saveToLocalStorage?: () => void;
  passFormId?: number;
}
export default function VehicleSelect(props: VehicleSelectProps): React.ReactElement {
  const {
    id, vehicle, setVehicle, required, saveToLocalStorage, passFormId
  } = props;
  const { data: vehiclesData } = useCompanyVehicles({
    fetchPolicy: 'cache-and-network',
  });
  const handleAddVehicleClick = () => {
    if(passFormId || passFormId === 0) {
      sessionStorage.setItem('passFormId', passFormId.toString());
    }
    // // Call saveToLocalStorage if it's defined
     saveToLocalStorage && saveToLocalStorage();
  };

  useEffect(() => {
    const passSessionFormId = sessionStorage.getItem('passFormId')  || '';
    const vehicleId = sessionStorage.getItem('vehicleId');
    
    if (vehicleId && passSessionFormId && vehiclesData?.getCompanyVehicles?.data && parseInt(passSessionFormId) === passFormId) {
      const vehicle = vehiclesData?.getCompanyVehicles?.data.find((v) => v.vehicleId === vehicleId);
      if (vehicle) {
        sessionStorage.removeItem('passFormId');
        sessionStorage.removeItem('vehicleId');
        setVehicle(newVehicleInfo(vehicle as unknown as Partial<VehicleInfo>));
      }
    }
  }, [vehiclesData]);

  return (
    <SelectTable<VehicleInfo>
      id={id}
      required={required}
      displayVal={(v) => (v ? `${v?.plateNumber} - ${v?.color} ${v?.make}` : '')}
      value={vehicle}
      setValue={setVehicle}
      preventClear
      validityTest={(obj) => !!(obj.plateNumber || obj.color || obj.make)}
      data={vehiclesData
        ?.getCompanyVehicles
        .data
        ?.map((d) => newVehicleInfo(d as unknown as Partial<VehicleInfo>)) || []}
      headers={[
        {
          label: 'Make',
          field: 'make',
        }, {
          label: 'License Plate',
          field: 'plateNumber',
        }, {
          label: 'Color',
          field: 'color',
        },
      ]}
      topHead={(
        <div>
          <Link to="/vendor/popup/add-edit-vehicle" onClick={handleAddVehicleClick}>Add Vehicle</Link>
        </div>
            )}
    />
  );
}
VehicleSelect.defaultProps = {
  vehicle: undefined,
  required: undefined,
};
